import { cn } from "../lib/utils";
import { avatarColorsForName } from "../lib/theme";

const SIZES = {
  sm: "h-8 w-8 text-[11px]",
  md: "h-9 w-9 text-xs",
  lg: "h-11 w-11 text-sm",
  xl: "h-14 w-14 text-base",
} as const;

function initials(name: string) {
  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

interface UserAvatarProps {
  name: string;
  size?: keyof typeof SIZES;
  className?: string;
}

export function UserAvatar({ name, size = "md", className }: UserAvatarProps) {
  const colors = avatarColorsForName(name);

  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full font-semibold ring-2 ring-white",
        SIZES[size],
        className,
      )}
      style={{ backgroundColor: colors.background, color: colors.color }}
      aria-hidden
    >
      {initials(name)}
    </div>
  );
}
